export default __webpack_public_path__ + "static/media/3_1_0.69987869.png";